<div class="form-badge" [ngClass]="color ? 'form-badge--' + color : null">
  <fa-icon *ngIf="icon" [icon]="icon"></fa-icon>
</div>
